import { format } from "date-fns";

export function filename(name) {
  const randomId = Math.floor(1000 + Math.random() * 9000);
  const dateString = format(new Date(), "yyyyMMdd");
  return `${name}_${dateString}_${randomId}`;
}